function resetErrorList (parentSelector, fieldErrors) { // eslint-disable-line
  $.each(fieldErrors, (attr) => {
    const field = $('*[name=' + attr + ']', parentSelector);
    if (field.length > 0 && field.parsley()) {
      field.parsley().removeError('error', { updateClass: true });
    }
  });
}

/**
 * Display error messages and highlight form fields with errors.
 * @param {string} parentSelector - the form which contains the fields
 * @param {Object} fieldErrors - the fields with errors
 * @param {Boolean} trackErrors - if true, error GTM trackers are launched with the form validation
 */
function loadFormErrors (parentSelector, fieldErrors, trackErrors) { // eslint-disable-line
  if (typeof trackErrors === 'undefined') {
    trackErrors = false;
  }

  var errorList = [];
  // Display error messages and highlight form fields with errors.
  $.each(fieldErrors, (attr) => {
    const field = $('*[name=' + attr + ']', parentSelector);

    if (field.length > 0) {
      if (field.parsley()) {
        field.parsley().removeError('error');
        field.parsley().addError('error', { message: fieldErrors[attr], updateClass: true });
      }
      field.parent('label').removeClass('is-valid-label').addClass('is-invalid-label');
      errorList.push(field.get(0));
    }
  });

  if (errorList.length > 0 && trackErrors) {
    $(window).trigger('submittedForm:error', { errorList: errorList.slice(0) });
  }
}

/**
 * Clear the form errors.
 * @param {string} parentSelector - the parent form selector.
 */
function clearPreviousErrors(parentSelector) {
  parentSelector.find('.is-invalid-label').removeClass('is-invalid-label');
  parentSelector.find('.is-invalid-input').removeClass('is-invalid-input');
  parentSelector.find('.errors-list').remove();
  parentSelector.find('.parsley-errors-list').remove();
}

module.exports = {
  resetErrorList: resetErrorList,
  loadFormErrors: loadFormErrors,
  clearPreviousErrors: clearPreviousErrors
};



// WEBPACK FOOTER //
// ./assets/scripts/util/formErrors.js